import type {MaybeRefOrGetter} from 'vue';
import {useRouteParams} from '@vueuse/router';
import {storeToRefs} from 'pinia';
import {useStoryblokHypermarketsStore} from '~/stores/storyblokHypermarkets';

export function useSelectedHypermarketRouteSync(branch?: MaybeRefOrGetter<string | undefined | null>) {
	const routeBranch = branch ?? useRouteParams<string | undefined>('branch');
	const {selectedHypermarket} = storeToRefs(useStoryblokHypermarketsStore());

	watch(() => selectedHypermarket.value, (newValue) => {
		if (!newValue || newValue === toValue(routeBranch)) {
			return;
		}

		navigateTo({params: {branch: newValue}});
	});
}
